/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsToggleDividendsReinvest204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsToggleDividendsReinvest505Schema = z.any();

export const optionsToggleDividendsReinvestMutationResponseSchema = z.lazy(
  () => optionsToggleDividendsReinvest204Schema
);
